<template>
  <div class="py-5">
    <b-container>
      <b-badge v-if="env !== 'production'" variant="warning" class="mb-3">{{ env }}</b-badge>
      <b-card no-body>
        <b-tabs v-model="activetab" pills content-class="m-0" card lazy>
          <b-tab no-body :title="$t('text.admin.elslutbleck')">
            <AdminEbDashboard></AdminEbDashboard>
          </b-tab>
          <b-tab no-body :title="$t('text.admin.lashus')">
            <AdminLhDashboard></AdminLhDashboard>
          </b-tab>
          <b-tab no-body :title="$t('text.admin.monteringsstolpar')">
            <AdminMsDashboard></AdminMsDashboard>
          </b-tab>
          <b-tab no-body :title="$t('text.admin.eltryckeslas_motorlas')">
            <AdminEmDashboard></AdminEmDashboard>
          </b-tab>
          <b-tab no-body :title="$t('text.admin.slutbleck')">
            <AdminSbDashboard></AdminSbDashboard>
          </b-tab>
          <b-tab no-body :title="$t('text.admin.nodutrymningsbeslag')">
            <AdminNbDashboard></AdminNbDashboard>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import ApiServiceAdmin from "@/services/ApiServiceAdmin";
import AdminEbDashboard from "@/components/admin/AdminEbDashboard";
import AdminMsDashboard from "@/components/admin/AdminMsDashboard";
import AdminLhDashboard from "@/components/admin/AdminLhDashboard";
import AdminEmDashboard from "@/components/admin/AdminEmDashboard";
import AdminSbDashboard from "@/components/admin/AdminSbDashboard";
import AdminNbDashboard from "@/components/admin/AdminNbDashboard";
export default {
  name: "AdminDashboard",
  components: {
    AdminEbDashboard,
    AdminMsDashboard,
    AdminLhDashboard,
    AdminEmDashboard,
    AdminSbDashboard,
    AdminNbDashboard,
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
      activetab: parseInt(localStorage.getItem('esb-activetab'))
    };
  },
  methods: {
    fetchLastActivity() {
      ApiServiceAdmin.getLastActivity().then(() => {
        // Do nothing... just for checking auth
      });
    },
  },
  mounted() {
    this.fetchLastActivity();
  },
  beforeUpdate() {
    // If logged in and has access_level = 2 (norway), we should set language to norwegian
    const access_level = this.$store.state.user.access_level;
    switch (access_level) {
      case "2":
        console.log('is 2')
        this.$i18n.locale = "no"; 
        break;
        case "3":
        console.log('is 3')
        this.$i18n.locale = "dk";
        break;
        default:
        console.log('is default')
        this.$i18n.locale = "sv";
        break;
    }
    // console.log('HELLLLELE')
    this.$i18n.locale = localStorage.getItem("langcode");
    localStorage.setItem("langcode", this.$i18n.locale);
  },
  watch: {
    activetab() {
      this.fetchLastActivity();
      localStorage.setItem('esb-activetab', this.activetab)
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1440px;
}
</style>
